import React from 'react';

import icons from './../../config/icons';

const Icon = ({ className, type }) => type ? (
    <span className={className}>{icons[type]}</span>
) : null;

export default Icon;
